import styled, { css } from "styled-components";

import { ToggleMenuButton } from "../../context-menu/context-menu.styles";
import { FillParent } from "../layout";
import { Wrapper as UploadWrapper } from "./upload/upload.styles";

export const Wrapper = styled.article<{
    width: string;
    height: string;
}>`
    width: ${(props) => `${props.width}`};
    height: ${(props) => `${props.height}`};
    position: relative;
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.colors.backgroundGreySecondary};
    color: ${({ theme }) => theme.colors.text9};
    background-color: #fafafa;
    transition: background-color linear 0.3s;
    border-radius: 3px;
    overflow: hidden;
`;

export const Footer = styled.footer`
    color: ${({ theme }) => theme.colors.text9};
    position: relative;
    text-overflow: ellipsis;
    background: white;
    border-top: 1px solid ${({ theme }) => theme.colors.backgroundGreySecondary};
    font-size: 12px;
    display: flex;
    justify-content: space-between;

    ${ToggleMenuButton} {
        i {
            display: block;
            font-size: 25px;
        }
    }
`;

export const FooterText = styled.div<{ isCompact?: boolean }>`
    padding: ${({ isCompact }) => (isCompact ? `5px` : `15px`)};
    ${(props) => {
        if (props.isCompact) {
            return css`
                display: flex;
                align-items: center;
            `;
        }
    }}
`;

export const Inner = styled.section<{
    isSquare?: boolean;
    isCompact?: boolean;
}>`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    aspect-ratio: ${({ isSquare }) => (isSquare ? `1 / 1` : `auto`)};

    ${UploadWrapper} {
        z-index: 15;
        background: ${(props) => props.theme.colors.uploadBackground};
        ${FillParent}
    }

    [name="upload"] {
        font-size: ${({ isCompact }) => (isCompact ? `55px` : `85px`)};
        margin-top: -10px;
        display: inline-block;
    }

    > p {
        padding: 0 6px;
        font-size: 10px;
        text-align: center;
    }
`;

export const Preview = styled.div`
    ${FillParent}

    background: url(/static/img/checker.jpg) repeat;
    z-index: 5;

    > div {
        width: 100%;
        height: 100%;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
